import React from 'react';

import { useSoyuzData } from '@spotahome/soyuz/client';

import { ToastContainer } from '@spotahome/ui-library';
import Metrics from '@spotahome/soyuz-metrics';

import HeaderContainer from '../../common/components/HeaderContainer';
import SessionExpiredModal from '../../common/components/SessionExpiredModal';
import Cookies from '../../common/components/Cookies';
import Footer from '../../common/components/Footer';

import { getAlerts as requestAlerts } from '../../common/graphql/queries/alerts';

import Alerts from './components/Alerts';

import useAlerts from './useAlerts';

import '../../common/scss/init.scss';

async function getAlerts(gqlClient) {
  try {
    const response = await requestAlerts(gqlClient)();

    return {
      alerts: response.data.alerts,
      isLogged: response.data.isLogged,
      userInfo: response.data.userInfo,
      cities: response.data.cities
    };
  } catch (error) {
    console.error(error);
    return { alerts: [], isLogged: false };
  }
}

const PAGE_NAME = 'AlertsPage';

const AlertsPage = () => {
  const { [PAGE_NAME]: data } = useSoyuzData();
  const { addAlert, editAlert, removeAlert, alerts } = useAlerts(data.alerts);

  const handleAdd = newAlert => {
    Metrics.ga.sendEvent('My alerts', 'create alert button', 'click button');
    addAlert(newAlert);
  };

  return (
    <div>
      <ToastContainer />
      <HeaderContainer />
      <Alerts
        initialQuery={data.query}
        userInfo={data.userInfo}
        isLogged={data.isLogged}
        cities={data.cities}
        alerts={alerts}
        onAdd={handleAdd}
        onEdit={editAlert}
        onRemove={removeAlert}
      />
      <SessionExpiredModal />
      <Cookies />
      <Footer />
    </div>
  );
};

AlertsPage.NAME = PAGE_NAME;
AlertsPage.requestAllData = async ({ query }, _, { graphqlClient }) => {
  const alertsData = await getAlerts(graphqlClient);

  return {
    headers: {},
    data: {
      query,
      ...alertsData
    }
  };
};
export default AlertsPage;
